var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-card-subtitle', [_vm._v("썸네일")]), _c('v-divider'), _c('v-card-text', {
    staticClass: "ml-4"
  }, [_vm.value.thumb ? _c('v-img', {
    attrs: {
      "src": _vm.value.thumb,
      "contain": "",
      "max-width": "180",
      "max-height": "180"
    }
  }) : _c('v-responsive', {
    attrs: {
      "width": "180",
      "height": "180"
    }
  }, [_c('v-row', {
    staticClass: "fill-height ma-0 grey lighten-3",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-icon', [_vm._v("mdi-image")])], 1)], 1)], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('v-card-subtitle', [_vm._v("기본정보")]), _c('v-divider'), _c('v-card-text', [_c('v-row', {
    staticClass: "ma-n2",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "pa-4",
    attrs: {
      "cols": "8"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "상품권명",
      "readonly": ""
    },
    model: {
      value: _vm.value.name,
      callback: function ($$v) {
        _vm.$set(_vm.value, "name", $$v);
      },
      expression: "value.name"
    }
  })], 1), _c('v-col', {
    staticClass: "pa-4",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "제공업체",
      "readonly": ""
    },
    model: {
      value: _vm.value.platform,
      callback: function ($$v) {
        _vm.$set(_vm.value, "platform", $$v);
      },
      expression: "value.platform"
    }
  })], 1), _c('v-col', {
    staticClass: "pa-4",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "권종",
      "readonly": ""
    },
    model: {
      value: _vm.value.faceamt,
      callback: function ($$v) {
        _vm.$set(_vm.value, "faceamt", $$v);
      },
      expression: "value.faceamt"
    }
  })], 1), _c('v-col', {
    staticClass: "pa-4",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "API 할인율",
      "readonly": ""
    },
    model: {
      value: _vm.value.cpamtRate,
      callback: function ($$v) {
        _vm.$set(_vm.value, "cpamtRate", $$v);
      },
      expression: "value.cpamtRate"
    }
  })], 1), _c('v-col', {
    staticClass: "pa-4",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "API 가격",
      "readonly": ""
    },
    model: {
      value: _vm.value.cpamt,
      callback: function ($$v) {
        _vm.$set(_vm.value, "cpamt", $$v);
      },
      expression: "value.cpamt"
    }
  })], 1), _c('v-col', {
    staticClass: "pa-4 pl-6",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "API 여부",
      "readonly": ""
    },
    model: {
      value: _vm.value.isApi,
      callback: function ($$v) {
        _vm.$set(_vm.value, "isApi", $$v);
      },
      expression: "value.isApi"
    }
  })], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }